<template>
  <div class="search-info">
    <div v-if="typeName" class="info">
      {{ $t(typeName) }} (<a class="link" @click="updateCurrentType">
        {{ quantity }}
      </a>)
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchInfo',
  components: {},
  directives: {},
  props: {
    typeName: {
      type: String,
      default: ''
    },
    typeKey: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {
    currentType() {
      return this.$store.state.search.type
    },
    quantity() {
      if (this.typeKey) {
        const matchObj = this.$store.state.search.results.find(searchObj => searchObj[this.typeKey])
        return matchObj ? matchObj.total : 0
      } else {
        return 0
      }
    }
  },
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    updateCurrentType() {
      if (this.currentType !== this.typeKey) {
        this.$emit('update', this.typeKey)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.search-info {
  margin-top: 24px;
  margin-bottom: 24px;
  .info {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.6;
    color: #505050;
  }
  .link {
    text-decoration: none;
    color: $link-hover;
    cursor: pointer;
  }
}
@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
  .search-info {
    .info {
      font-size: 16px;
      font-weight: 700;
      line-height: 1.63;
      color: $grey-9b;
    }
  }
}
@media only screen and (max-width: 767.98px) {
  .search-info {
    .info {
      font-size: 16px;
      font-weight: 700;
      line-height: 1.63;
      color: $grey-7d;
    }
  }
}

</style>
